import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  searchResultFooter: {},
  searchItemIsGroup: {},
  searchBarWrapper: {
    position: "relative",
    minWidth: "50%",
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(2, 4),
    },
  },
  searchBarInnerWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: 40,
    padding: 10,
    [theme.breakpoints.down("sm")]: {
      borderRadius: 30,
    },
    border: "1px solid #fff",
    transition: "border 0.4s ease-in-out",
    "&:hover, &:focus": {
      boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
    },
  },
  searchBarInnerWrapperSmall: {
    borderRadius: 30,
    border: "1px solid #fff",
    transition: "border 0.4s ease-in-out",
    "&:hover, &:focus": {
      boxShadow: "2px 2px 9px 2px rgba(255,255,255,0.7)",
    },
  },
  searchBarInnerWrapperOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    height: 60,
    [theme.breakpoints.down("sm")]: {
      height: 40,
    },
  },
  inputSmall: {
    height: 40,
  },
  iconButton: {
    padding: 10,
    display: 'flex',
    alignItems: "center",
    color: 'rgb(175, 179, 187)',
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  selectedSearchText: {
    padding: theme.spacing(0, 1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1),
    },
  },
  downArrow: {
    padding: theme.spacing(0, 1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1),
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 1.5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1),
    },
  },
  searchDropdownWrapper: {
    padding: 10,
  },
  divider: {
    height: "28px",
    margin: "4px",
  },
  searchResultWrapper: {
    display: "none",
  },
  searchResultWrapperOpen: {
    display: "flex",
    flexDirection: 'column',
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 9,
    maxHeight: 250,
    overflow: 'hidden',
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 15px 14px 2px rgb(0 0 0 / 12%)',
    borderBottomLeftRadius: 40,
    borderBottomRightRadius: 40,
  },
  smallSearchResultWrapperOpen: {
    borderBottomLeftRadius: 30,
    borderBottomRightRadius: 30,
  },
  searchResultListWrapper: {
    overflow: 'auto',
  },
  searchItem: {
    color: "#000",
    display: 'flex',
    alignItems: "center",
    padding: theme.spacing(.5),
    textDecoration: "none",
    "&:hover": {
      backgroundColor: "rgb(241, 242, 246)",
      textDecoration: "none",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      flexWrap: "wrap",
    },
  },
  searchItemMore: {
    display: 'flex',
    alignItems: "center",
    padding: theme.spacing(.5),
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  searchAvatar: {
    margin: theme.spacing(0, 2.5),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(0, 1.5),
    },
  },
  avatarStyle: {
    backgroundColor: '#000000!important',
    color: 'white',
    width: "20px",
    height: "20px",
    fontSize: '.80rem',

  },
  searchName: {
    color: "#000",
    width: 'calc(50% - 100px)',
    [theme.breakpoints.down("sm")]: {
      width: 'calc(100% - 60px)',
      whiteSpace: "nowrap",
      overflow: 'hidden',
      textOverflow: "ellipsis",
    },
  },
  searchRole: {
    width: '25%',
    [theme.breakpoints.down("sm")]: {
      width: 'calc(60% - 54px)',
      whiteSpace: "nowrap",
      overflow: 'hidden',
      textOverflow: "ellipsis",
    },
  },
  searchStatus: {
    width: '25%',
    [theme.breakpoints.down("sm")]: {
      width: '40%',
      whiteSpace: "nowrap",
      overflow: 'hidden',
      textOverflow: "ellipsis",
      marginLeft: 54,
    },
  },
  searchMore: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 500,
    color: "rgb(23, 132, 255)",
    margin: theme.spacing(5, 0),
    cursor: 'pointer',
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1.5, 0),
    },
  },
  searchItemNoResult: {
    textAlign: 'center',
    fontWeight: 500,
    color: "rgb(23, 132, 255)",
    margin: theme.spacing(2)
  }
}));
